import React, { useEffect, useState } from "react";
import {
  Button,
  Input,
  Tabs,
  Card,
  Form,
  message,
  Table,
  Modal,
  Select,
  Row,
  Col,
} from "antd";
import { professionalAction } from "../../_actions";
import { connect } from "react-redux";
import { DatePicker } from "antd";
import moment from "moment";
import axios from "axios";
import { ViewVehicleData } from "./ViewVehicleData";
import { ViewDrivingLicenceData } from "./ViewDrivingLicenceData";
import { ViewAadharData } from "./ViewAadharData";
import { ViewAadharOTPData } from "./ViewAadharOTPData";
import { ViewVoterData } from "./ViewVoterData";
import { ViewPassportData } from "./ViewPassportData";
import { ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons";
import { ImageViewOnly } from "../image/onlyImageVIew";

const { TabPane } = Tabs;

const DocumentVerification = (props) => {
  const [selectedDocument, setSelectedDocument] = useState("Vehicle Number");
  const [form] = Form.useForm();
  const [submittedTabs, setSubmittedTabs] = useState({});
  const [loading, setLoading] = useState(false);
  const [showOtpField, setShowOtpField] = useState(false);
  const [aaddhar, setAaddhar] = useState("");
  const [clientId, setClientId] = useState("");
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [tabKeyData, setTabKeyData] = useState({
    vehicleNumber: [],
    drivingLicense: [],
    aadharNumber: [],
    aadharOtp: [],
    voterId: [],
    passport: [],
  });
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [ipAddress, setIpAddress] = useState("");
  const [aadharError, setAadharError] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [sortOrder, setSortOrder] = useState("DESC");
  const [imageOpen, setImageOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  const openImageModal = (img) => {
    setImageOpen(true);
    setSelectedImage(img);
  };

  const closeImageModal = () => {
    setImageOpen(false);
    setSelectedImage(null);
  };

  const { user } = props;
  const { Option } = Select;

  useEffect(() => {
    getData();
  }, []);

  const planData = localStorage.getItem("allocatedVerification") || "";

  const calculateRemainingDays = (expiryDate) => {
    const today = new Date();
    const expiry = new Date(expiryDate);
    const timeDiff = expiry - today;
    const remainingDays = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));
    return remainingDays;
  };

  let remainingDays = "";

  if (planData !== undefined && planData !== "") {
    try {
      var allocatedVerification = JSON.parse(planData);

      const expiryDate = allocatedVerification?.expriy_date;
      remainingDays = calculateRemainingDays(expiryDate);
    } catch (error) {
      console.error("Error parsing allocatedVerification:", error.message);
    }
  } else {
    console.log("No allocatedVerification data found.");
  }

  const tabColumns = {
    vehicleNumber: [
      {
        title: "Sr No",
        dataIndex: "serial_number",
        key: "serial_number",
        render: (_, __, index) => {
          return currentPage * pageSize + (index + 1);
        },
      },
      {
        title: "Rc Number",
        dataIndex: "rc_number",
        key: "rc_number",
      },
      {
        title: "Full Name",
        dataIndex: "owner_name",
        key: "owner_name",
      },
      {
        title: "Insurance Upto",
        dataIndex: "insurance_upto",
        key: "insurance_upto",
        render: (text) => moment(text).format("DD/MM/YYYY"),
      },
      {
        title: "Fit Upto",
        dataIndex: "fit_up_to",
        key: "fit_up_to",
        render: (text) => moment(text).format("DD/MM/YYYY"),
      },
      {
        title: "Make Model",
        dataIndex: "maker_model",
        key: "maker_model",
      },
      {
        title: (
          <div>
            Searched At
            <Button
              type={sortOrder === "asc" ? "primary" : "default"}
              size="small"
              onClick={() => setSortOrder("ASC")}
              style={{
                marginLeft: 8,
                padding: "0px 4px",
                borderRadius: "6px",
              }}
            >
              <ArrowUpOutlined></ArrowUpOutlined>
            </Button>
            <Button
              type={sortOrder === "desc" ? "primary" : "default"}
              size="small"
              onClick={() => setSortOrder("DESC")}
              style={{
                marginLeft: 3,
                padding: "0px 4px",
                borderRadius: "6px",
              }}
            >
              <ArrowDownOutlined></ArrowDownOutlined>
            </Button>
          </div>
        ),
        dataIndex: "createdAt",
        key: "createdAt",
        render: (text) => moment(text).format("DD/MM/YYYY"),
      },
      {
        title: "Action",
        key: "action",
        render: (record) => (
          <a style={{ cursor: "pointer" }} onClick={() => handleView(record)}>
            View
          </a>
        ),
      },
    ],
    drivingLicense: [
      {
        title: "Sr No",
        dataIndex: "serial_number",
        key: "serial_number",
        render: (_, __, index) => {
          return currentPage * pageSize + (index + 1);
        },
      },
      {
        title: "Licence Number",
        dataIndex: "license_number",
        key: "license_number",
      },
      { title: "Full Name", dataIndex: "name", key: "name" },
      {
        title: "DOB",
        dataIndex: "dob",
        key: "dob",
        render: (text) => moment(text).format("DD/MM/YYYY"),
      },
      {
        title: (
          <div>
            Searched At
            <Button
              type={sortOrder === "asc" ? "primary" : "default"}
              size="small"
              onClick={() => setSortOrder("ASC")}
              style={{ marginLeft: 8, padding: "0px 4px", borderRadius: "6px" }}
            >
              <ArrowUpOutlined></ArrowUpOutlined>
            </Button>
            <Button
              type={sortOrder === "desc" ? "primary" : "default"}
              size="small"
              onClick={() => setSortOrder("DESC")}
              style={{ marginLeft: 3, padding: "0px 4px", borderRadius: "6px" }}
            >
              <ArrowDownOutlined></ArrowDownOutlined>
            </Button>
          </div>
        ),
        dataIndex: "createdAt",
        key: "createdAt",
        render: (text) => moment(text).format("DD/MM/YYYY"),
      },
      {
        title: "Action",
        key: "action",
        render: (record) => (
          <a style={{ cursor: "pointer" }} onClick={() => handleView(record)}>
            View
          </a>
        ),
      },
    ],
    aadharNumber: [
      {
        title: "Sr No",
        dataIndex: "serial_number",
        key: "serial_number",
        render: (_, __, index) => {
          return currentPage * pageSize + (index + 1);
        },
      },
      {
        title: "Aadhar Number",
        dataIndex: "aadhaar_number",
        key: "aadhaar_number",
      },
      {
        title: "Gender",
        dataIndex: "gender",
        key: "gender",
        render: (text) =>
          text === "F" ? "Female" : text === "M" ? "Male" : "Unknown",
      },
      { title: "Age Range", dataIndex: "age_range", key: "age_range" },
      { title: "State", dataIndex: "state", key: "state" },
      { title: "Last 3 digit", dataIndex: "last_digits", key: "last_digits" },
      {
        title: (
          <div>
            Searched At
            <Button
              type={sortOrder === "asc" ? "primary" : "default"}
              size="small"
              onClick={() => setSortOrder("ASC")}
              style={{ marginLeft: 8, padding: "0px 4px", borderRadius: "6px" }}
            >
              <ArrowUpOutlined></ArrowUpOutlined>
            </Button>
            <Button
              type={sortOrder === "desc" ? "primary" : "default"}
              size="small"
              onClick={() => setSortOrder("DESC")}
              style={{ marginLeft: 3, padding: "0px 4px", borderRadius: "6px" }}
            >
              <ArrowDownOutlined></ArrowDownOutlined>
            </Button>
          </div>
        ),
        dataIndex: "createdAt",
        key: "createdAt",
        render: (text) => moment(text).format("DD/MM/YYYY"),
      },
      {
        title: "Action",
        key: "action",
        render: (record) => (
          <a style={{ cursor: "pointer" }} onClick={() => handleView(record)}>
            View
          </a>
        ),
      },
    ],
    aadharOtp: [
      {
        title: "Sr No",
        dataIndex: "serial_number",
        key: "serial_number",
        render: (_, __, index) => {
          return currentPage * pageSize + (index + 1);
        },
      },
      {
        title: "Aadhar Number",
        dataIndex: "aadhaar_number",
        key: "aadhaar_number",
      },
      {
        title: "Full Name",
        dataIndex: "full_name",
        key: "full_name",
      },
      {
        title: "DOB",
        dataIndex: "dob",
        key: "dob",
        render: (text) => moment(text).format("DD/MM/YYYY"),
      },
      {
        title: "Gender",
        dataIndex: "gender",
        key: "gender",
        render: (text) =>
          text === "F" ? "Female" : text === "M" ? "Male" : "Unknown",
      },
      {
        title: "Profile Image",
        dataIndex: "profile_image",
        key: "profile_image",
        render: (text) => (
          <img
            src={`data:image/png;base64,${text}`}
            alt="Profile"
            style={{ width: 50, height: 50, borderRadius: "50%" }}
            onClick={() => openImageModal(`data:image/png;base64,${text}`)}
          />
        ),
      },
      {
        title: (
          <div>
            Searched At
            <Button
              type={sortOrder === "asc" ? "primary" : "default"}
              size="small"
              onClick={() => setSortOrder("ASC")}
              style={{ marginLeft: 8, padding: "0px 4px", borderRadius: "6px" }}
            >
              <ArrowUpOutlined></ArrowUpOutlined>
            </Button>
            <Button
              type={sortOrder === "desc" ? "primary" : "default"}
              size="small"
              onClick={() => setSortOrder("DESC")}
              style={{ marginLeft: 3, padding: "0px 4px", borderRadius: "6px" }}
            >
              <ArrowDownOutlined></ArrowDownOutlined>
            </Button>
          </div>
        ),
        dataIndex: "createdAt",
        key: "createdAt",
        render: (text) => moment(text).format("DD/MM/YYYY"),
      },
      {
        title: "Action",
        key: "action",
        render: (record) => (
          <a style={{ cursor: "pointer" }} onClick={() => handleView(record)}>
            View
          </a>
        ),
      },
    ],
    voterId: [
      {
        title: "Sr No",
        dataIndex: "serial_number",
        key: "serial_number",
        render: (_, __, index) => {
          return currentPage * pageSize + (index + 1);
        },
      },
      {
        title: "Voter Id",
        dataIndex: "epic_no",
        key: "epic_no",
      },
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "DOB",
        dataIndex: "dob",
        key: "dob",
        render: (text) => moment(text).format("DD/MM/YYYY"),
      },
      {
        title: "Assembly Constituency",
        dataIndex: "assembly_constituency",
        key: "assembly_constituency",
      },
      {
        title: "Parliamentary Constituency",
        dataIndex: "parliamentary_constituency",
        key: "parliamentary_constituency",
      },
      {
        title: (
          <div>
            Searched At
            <Button
              type={sortOrder === "asc" ? "primary" : "default"}
              size="small"
              onClick={() => setSortOrder("ASC")}
              style={{ marginLeft: 8, padding: "0px 4px", borderRadius: "6px" }}
            >
              <ArrowUpOutlined></ArrowUpOutlined>
            </Button>
            <Button
              type={sortOrder === "desc" ? "primary" : "default"}
              size="small"
              onClick={() => setSortOrder("DESC")}
              style={{ marginLeft: 3, padding: "0px 4px", borderRadius: "6px" }}
            >
              <ArrowDownOutlined></ArrowDownOutlined>
            </Button>
          </div>
        ),
        dataIndex: "createdAt",
        key: "createdAt",
        render: (text) => moment(text).format("DD/MM/YYYY"),
      },
      {
        title: "Action",
        key: "action",
        render: (record) => (
          <a style={{ cursor: "pointer" }} onClick={() => handleView(record)}>
            View
          </a>
        ),
      },
    ],
    PassportDetails: [
      {
        title: "Sr No",
        dataIndex: "serial_number",
        key: "serial_number",
        render: (_, __, index) => {
          return currentPage * pageSize + (index + 1);
        },
      },
      {
        title: "File Number",
        dataIndex: "file_number",
        key: "file_number",
      },
      {
        title: "Name",
        dataIndex: "full_name",
        key: "full_name",
      },
      {
        title: "DOB",
        dataIndex: "dob",
        key: "dob",
        render: (text) => moment(text).format("DD/MM/YYYY"),
      },
      {
        title: "Passport Number",
        dataIndex: "passport_number",
        key: "passport_number",
      },
      {
        title: "Date of Application",
        dataIndex: "date_of_application",
        render: (text) => moment(text).format("DD/MM/YYYY"),
      },
      {
        title: (
          <div>
            Searched At
            <Button
              type={sortOrder === "asc" ? "primary" : "default"}
              size="small"
              onClick={() => setSortOrder("ASC")}
              style={{ marginLeft: 8, padding: "0px 4px", borderRadius: "6px" }}
            >
              <ArrowUpOutlined></ArrowUpOutlined>
            </Button>
            <Button
              type={sortOrder === "desc" ? "primary" : "default"}
              size="small"
              onClick={() => setSortOrder("DESC")}
              style={{ marginLeft: 3, padding: "0px 4px", borderRadius: "6px" }}
            >
              <ArrowDownOutlined></ArrowDownOutlined>
            </Button>
          </div>
        ),
        dataIndex: "createdAt",
        key: "createdAt",
        render: (text) => moment(text).format("DD/MM/YYYY"),
      },
      {
        title: "Action",
        key: "action",
        render: (record) => (
          <a style={{ cursor: "pointer" }} onClick={() => handleView(record)}>
            View
          </a>
        ),
      },
    ],
  };

  const getData = async () => {
    const res = await axios.get(
      `${process.env.REACT_APP_GEOLOCATION_URL}/json/`
    );
    setIpAddress(res.data.IPv4);
  };

  const handleView = (record) => {
    setSelectedRecord(record);
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
    setSelectedRecord(null);
  };

  useEffect(() => {
    fetchData(selectedDocument, currentPage, pageSize);
  }, [selectedDocument, currentPage, pageSize, sortOrder]);

  const handlePageChange = (page, size) => {
    console.log("page", page, size);
    setCurrentPage(page - 1);
    setPageSize(size);
  };

  const fetchData = async (tabKey, page, size) => {
    setLoading(true);
    try {
      const apiEndpoints = {
        "Vehicle Number": () =>
          professionalAction.getVehicleDetails(user?.id, page, size, sortOrder),
        "Driving License": () =>
          professionalAction.getDrivingLicenseDetails(
            user?.id,
            page,
            size,
            sortOrder
          ),
        "Aadhar Number": () =>
          professionalAction.getAadharBasicDetails(
            user?.id,
            page,
            size,
            sortOrder
          ),
        "Aadhar Number (OTP)": () =>
          professionalAction.getAadharOtpDetails(
            user?.id,
            page,
            size,
            sortOrder
          ),
        "Voter ID": () =>
          professionalAction.getVoterDetails(user?.id, page, size, sortOrder),
        "Passport Details": () =>
          professionalAction.getPassportDetails(
            user?.id,
            page,
            size,
            sortOrder
          ),
      };

      const response = await apiEndpoints[tabKey]();
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const result = await response.json();
      setTabKeyData((prev) => ({
        ...prev,
        [getStateKey(tabKey)]: result?.res1?.dataItem,
      }));
      setColumns(tabColumns[getStateKey(tabKey)]);
      setData(result?.res1?.dataItem);
      setTotal(result?.res1?.totalItems);
    } catch (error) {
      message.error("Error fetching data: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const getStateKey = (tabKey) => {
    switch (tabKey) {
      case "Vehicle Number":
        return "vehicleNumber";
      case "Driving License":
        return "drivingLicense";
      case "Aadhar Number":
        return "aadharNumber";
      case "Aadhar Number (OTP)":
        return "aadharOtp";
      case "Voter ID":
        return "voterId";
      case "Passport Details":
        return "PassportDetails";
      default:
        return "";
    }
  };

  const handleTabChange = (key) => {
    setCurrentPage(0);
    setPageSize(10);
    setSelectedDocument(key);
    form.resetFields();
    setData(tabKeyData[getStateKey(key)] || []);
    // if (!tabKeyData[getStateKey(key)]?.length) {
    //   fetchData(key, currentPage, pageSize);
    // }
  };

  const handleInputChange = (e) => {
    const value = e.target.value.toUpperCase();
    form.setFieldsValue({ documentNumber: value });
  };

  const getPlaceholder = () => {
    switch (selectedDocument) {
      case "Vehicle Number":
        return "Enter your Vehicle Registration Number (e.g. MH12AB1234)";
      case "Driving License":
        return "Enter your Driving License Number (e.g. HR-0619850034761 or HR06 19850034761)";
      case "Aadhar Number":
        return "Enter your 12-digit Aadhar Number";
      case "Aadhar Number (OTP)":
        return "Enter Aadhar Number for OTP verification";
      case "PAN Comprehensive":
        return "Enter your PAN Number (e.g. ABCDE1234F)";
      // case "PAN Name":
      //   return "Enter your name as per PAN card";
      case "Voter ID":
        return "Enter your Voter ID (e.g. ABC1234567)";
      case "Passport Details":
        return "Enter File Number of Passport";
      default:
        return "Enter Document Number";
    }
  };

  const getValidationRules = () => {
    switch (selectedDocument) {
      case "Vehicle Number":
        return [
          { required: true, message: "Vehicle Number is required" },
          {
            pattern: /^[A-Z]{2}\d{2}[A-Z]{2}\d{4}$/,
            message: "Vehicle Number must be in format (e.g. MH12AB1234)",
          },
        ];
      case "Driving License":
        return [
          { required: true, message: "Driving License Number is required" },
          {
            validator: (_, value) => {
              const regex = /^[A-Z]{2}[ -]?\d{2}[ -]?\d{4}[ -]?\d{7}$/;
              if (!value || regex.test(value)) {
                const cleanValue = value.replace(/[ -]/g, "");
                const isValid = /^[A-Z]{2}\d{2}\d{4}\d{7}$/.test(cleanValue);
                return isValid
                  ? Promise.resolve()
                  : Promise.reject(
                      "Driving License should follow the format: HR-0619850034761 or HR06 19850034761"
                    );
              }
              return Promise.reject(
                "Driving License should follow the format: HR-0619850034761 or HR06 19850034761"
              );
            },
          },
        ];
      case "Aadhar Number":
        return [
          { required: true, message: "Aadhar Number is required" },
          {
            pattern: /^[1-9]\d{11}$/,
            message:
              "Aadhar Number must be a 12-digit number starting with 1-9",
          },
        ];
      case "Aadhar Number (OTP)":
        return [
          {
            required: true,
            message: "OTP is required!",
          },
          {
            pattern: /^\d{6}$/,
            message: "OTP must be a 6-digit numeric value!",
          },
        ];
      case "PAN Comprehensive":
        return [
          { required: true, message: "PAN Number is required" },
          {
            pattern: /^[A-Z]{5}\d{4}[A-Z]{1}$/,
            message: "PAN Number must be in format (e.g. ABCDE1234F)",
          },
        ];
      // case "PAN Name":
      //   return [
      //     { required: true, message: "Name is required" },
      //     { min: 3, message: "Name should be at least 3 characters long" },
      //   ];
      case "Voter ID":
        return [
          { required: true, message: "Voter ID is required" },
          {
            pattern: /^[A-Z]{3}\d{7}$/,
            message: "Voter ID must be in format (e.g. ABC1234567)",
          },
        ];
      case "Passport Details":
        return [
          { required: true, message: "Passport File Number is required" },
          {
            pattern: /^PN\d{13}$/,
            message: "Enter your Passport File No (e.g. PN1234567891234)",
          },
        ];
      default:
        return [{ required: true, message: "Document is required" }];
    }
  };

  const validateAadharNumber = (aadhar) => {
    if (!aadhar || aadhar.trim() === "") {
      return "Aadhar Number is required";
    }
    if (!/^[1-9]\d{11}$/.test(aadhar)) {
      return "Aadhar Number must be a 12-digit number starting with 1-9";
    }
    return null;
  };

  const handleAadhaarChange = (value) => {
    setAaddhar(value);

    const error = validateAadharNumber(value);
    setAadharError(error);
  };

  const generateAadharOtp = async () => {
    const error = validateAadharNumber(aaddhar);
    if (error) {
      setAadharError(error);
      return;
    }

    setAadharError("");
    setLoading(true);

    try {
      const req = { id_number: aaddhar };

      const response = await professionalAction.generateOtp(req);
      const data = await response.json();

      if (response.ok && data.success) {
        setShowOtpField(true);
        setClientId(data?.data?.client_id);
        message.success("OTP sent successfully!");
      } else {
        setShowOtpField(false);
        message.error(data?.message || "Failed to send OTP. Please try again.");
      }
    } catch (error) {
      message.error("An unexpected error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const saveVehicleDetails = async (selectedDocument, values) => {
    console.log("saveVehicleDetails", values);
    const data = {
      id_number: values.documentNumber,
    };
    setLoading(true);

    try {
      const thirdPartyResponse =
        await professionalAction.addVehicalDetailsThirdParty(data);
      if (!thirdPartyResponse.ok) {
        const errorDetail = await thirdPartyResponse.json();
        throw new Error(
          errorDetail.message ||
            "Failed to validate vehicle details with third-party service"
        );
      }

      const thirdPartyData = await thirdPartyResponse.json();
      thirdPartyData.data["user_id"] = user.id;
      thirdPartyData.data["ip_address"] = ipAddress;
      thirdPartyData.data["type"] = values?.type;
      thirdPartyData.data["details"] = values?.details;

      const requestData = thirdPartyData.data;

      Object.keys(requestData).forEach((key) => {
        if (requestData[key] === null) {
          requestData[key] = "";
        }
      });

      // const requestData = {
      //   blacklist_status: "",
      //   body_type: "SOLO",
      //   challan_details: "",
      //   client_id: "rc_uzvjlelwxefWypEmohIw",
      //   color: "SCCRSRD",
      //   cubic_capacity: "100",
      //   father_name: "HARIBHAU",
      //   financed: "0e",
      //   financer: "",
      //   fit_up_to: "2027-05-03",
      //   fuel_type: "PETROL",
      //   insurance_company: "Bajaj Allianz General Insurance Co. Ltd.",
      //   insurance_policy_number: "OG-25-9906-1802-00060987",
      //   insurance_upto: "2025-05-16",
      //   latest_by: "2024-08-06",
      //   less_info: "1",
      //   maker_description: "HERO HONDA MOTORS  LTD",
      //   maker_model: "PASSION PRO",
      //   manufacturing_date: "4/2012",
      //   manufacturing_date_formatted: "2012-04",
      //   masked_name: "0e",
      //   mobile_number: "",
      //   national_permit_issued_by: "",
      //   national_permit_number: "",
      //   national_permit_upto: "",
      //   no_cylinders: "1",
      //   noc_details: "",
      //   non_use_from: "",
      //   non_use_status: "",
      //   non_use_to: "",
      //   norms_type: "Not Available",
      //   owner_name: "SHITOLE MANGESH HARIBHAU",
      //   owner_number: "1",
      //   permanent_address: "",
      //   user_id: "196",
      // };

      const mainServiceResponse = await professionalAction.addVehicalDetails(
        requestData
      );

      if (!mainServiceResponse.ok) {
        const errorDetail = await mainServiceResponse.json();
        throw new Error(
          errorDetail.message ||
            "Failed to add vehicle details to the main service"
        );
      }

      message.success(`${selectedDocument} submitted successfully`);
      setSubmittedTabs((prev) => ({ ...prev, [selectedDocument]: true }));
      fetchData(selectedDocument, currentPage, pageSize, sortOrder);
    } catch (error) {
      const errorMessage =
        error.message ||
        "An unexpected error occurred while processing your request.";
      message.error(errorMessage);
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const saveDrivingLicense = async (selectedDocument, values) => {
    const drivingLicence = values.documentNumber;
    const dob = moment(values.dob).format("YYYY-MM-DD");

    const formattedData = {
      id_number: drivingLicence,
      dob: dob,
    };
    setLoading(true);

    try {
      const thirdPartyResponse =
        await professionalAction.addDrivinglicenceThirdParty(formattedData);
      if (!thirdPartyResponse.ok) {
        const errorDetail = await thirdPartyResponse.json();
        throw new Error(
          errorDetail.message ||
            "Failed to validate Driving License with third-party service"
        );
      }

      const thirdPartyData = await thirdPartyResponse.json();
      thirdPartyData.data["user_id"] = user.id;
      thirdPartyData.data["ip_address"] = ipAddress;
      thirdPartyData.data["type"] = values?.type;
      thirdPartyData.data["details"] = values?.details;

      const requestData = thirdPartyData.data;

      const mainServiceResponse = await professionalAction.addDrivinglicence(
        requestData
      );

      if (!mainServiceResponse.ok) {
        const errorDetail = await mainServiceResponse.json();
        throw new Error(
          errorDetail.message ||
            "Failed to validate Driving License with the main service"
        );
      }

      message.success(`${selectedDocument} submitted successfully`);
      setSubmittedTabs((prev) => ({ ...prev, [selectedDocument]: true }));
      fetchData(selectedDocument, currentPage, pageSize, sortOrder);
    } catch (error) {
      const errorMessage =
        error.message ||
        "An unexpected error occurred while processing your request.";
      message.error(errorMessage);
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const saveAadharNumber = async (selectedDocument, values) => {
    const data = {
      id_number: values.documentNumber,
    };
    setLoading(true);

    try {
      const thirdPartyResponse =
        await professionalAction.addAadharBasicThirdParty(data);
      if (!thirdPartyResponse.ok) {
        const errorDetail = await thirdPartyResponse.json();
        throw new Error(
          errorDetail.message || "Failed to add Aadhar to third-party service"
        );
      }

      const thirdPartyData = await thirdPartyResponse.json();
      thirdPartyData.data["user_id"] = user.id;
      thirdPartyData.data["ip_address"] = ipAddress;
      thirdPartyData.data["type"] = values?.type;
      thirdPartyData.data["details"] = values?.details;

      const requestData = thirdPartyData.data;

      const mainServiceResponse = await professionalAction.addAadharBasic(
        requestData
      );

      if (!mainServiceResponse.ok) {
        const errorDetail = await mainServiceResponse.json();
        throw new Error(
          errorDetail.message || "Failed to add Aadhar to the main service"
        );
      }

      message.success(`${selectedDocument} submitted successfully`);
      setSubmittedTabs((prev) => ({ ...prev, [selectedDocument]: true }));
      fetchData(selectedDocument, currentPage, pageSize, sortOrder);
    } catch (error) {
      const errorMessage =
        error.message ||
        "An unexpected error occurred while processing your request.";
      message.error(errorMessage);
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const saveAadharOtp = async (selectedDocument, values) => {
    const data = {
      client_id: clientId,
      otp: values.documentNumber,
    };
    setLoading(true);

    try {
      const thirdPartyResponse =
        await professionalAction.addAadharotpThirdParty(data);
      if (!thirdPartyResponse.ok) {
        const errorDetail = await thirdPartyResponse.json();
        throw new Error(
          errorDetail.message ||
            "Failed to validate OTP with third-party service"
        );
      }

      const thirdPartyData = await thirdPartyResponse.json();
      thirdPartyData.data["user_id"] = user.id;
      thirdPartyData.data["ip_address"] = ipAddress;
      thirdPartyData.data["type"] = values?.type;
      thirdPartyData.data["details"] = values?.details;

      const requestData = thirdPartyData.data;

      const mainServiceResponse = await professionalAction.addAadharotp(
        requestData
      );

      if (!mainServiceResponse.ok) {
        const errorDetail = await mainServiceResponse.json();
        throw new Error(
          errorDetail.message || "Failed to validate OTP with the main service"
        );
      }

      message.success(`${selectedDocument} submitted successfully`);
      setSubmittedTabs((prev) => ({ ...prev, [selectedDocument]: true }));
      fetchData(selectedDocument, currentPage, pageSize, sortOrder);
    } catch (error) {
      const errorMessage =
        error.message ||
        "An unexpected error occurred while processing your request.";
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const saveVoterID = async (selectedDocument, values) => {
    const voterId = values.documentNumber;

    const formattedData = {
      id_number: voterId,
    };
    setLoading(true);

    try {
      const thirdPartyResponse = await professionalAction.addVoterThirdParty(
        formattedData
      );
      if (!thirdPartyResponse.ok) {
        const errorDetail = await thirdPartyResponse.json();
        throw new Error(
          errorDetail.message ||
            "Failed to validate Voter ID with third-party service"
        );
      }

      const thirdPartyData = await thirdPartyResponse.json();
      thirdPartyData.data["user_id"] = user.id;
      thirdPartyData.data["ip_address"] = ipAddress;
      thirdPartyData.data["type"] = values?.type;
      thirdPartyData.data["details"] = values?.details;

      const requestData = thirdPartyData.data;

      if (requestData.hasOwnProperty("id")) {
        delete requestData.id;
      }

      const mainServiceResponse = await professionalAction.addVoter(
        requestData
      );

      if (!mainServiceResponse.ok) {
        const errorDetail = await mainServiceResponse.json();
        throw new Error(
          errorDetail.message ||
            "Failed to validate Voter ID with the main service"
        );
      }

      message.success(`${selectedDocument} submitted successfully`);
      setSubmittedTabs((prev) => ({ ...prev, [selectedDocument]: true }));
      fetchData(selectedDocument, currentPage, pageSize, sortOrder);
    } catch (error) {
      const errorMessage =
        error.message ||
        "An unexpected error occurred while processing your request.";
      message.error(errorMessage);
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const savePassport = async (selectedDocument, values) => {
    const passport = values.documentNumber;
    const dob = moment(values.dob).format("YYYY-MM-DD");

    const formattedData = {
      id_number: passport,
      dob: dob,
    };
    setLoading(true);

    try {
      const thirdPartyResponse = await professionalAction.addPassportThirdParty(
        formattedData
      );
      if (!thirdPartyResponse.ok) {
        const errorDetail = await thirdPartyResponse.json();
        throw new Error(
          errorDetail.message ||
            "Failed to validate Passport with third-party service"
        );
      }

      const thirdPartyData = await thirdPartyResponse.json();
      thirdPartyData.data["user_id"] = user.id;
      thirdPartyData.data["ip_address"] = ipAddress;
      thirdPartyData.data["type"] = values?.type;
      thirdPartyData.data["details"] = values?.details;

      const requestData = thirdPartyData.data;

      const mainServiceResponse = await professionalAction.addPassport(
        requestData
      );

      if (!mainServiceResponse.ok) {
        const errorDetail = await mainServiceResponse.json();
        throw new Error(
          errorDetail.message ||
            "Failed to validate Passport with the main service"
        );
      }

      message.success(`${selectedDocument} submitted successfully`);
      setSubmittedTabs((prev) => ({ ...prev, [selectedDocument]: true }));
      fetchData(selectedDocument, currentPage, pageSize, sortOrder);
    } catch (error) {
      const errorMessage =
        error.message ||
        "An unexpected error occurred while processing your request.";
      message.error(errorMessage);
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        console.log("values", values);
        if (selectedDocument === "Vehicle Number")
          saveVehicleDetails(selectedDocument, values);
        if (selectedDocument === "Driving License")
          saveDrivingLicense(selectedDocument, values);
        if (selectedDocument === "Aadhar Number")
          saveAadharNumber(selectedDocument, values);
        if (selectedDocument === "Aadhar Number (OTP)")
          saveAadharOtp(selectedDocument, values);
        if (selectedDocument === "Voter ID")
          saveVoterID(selectedDocument, values);
        if (selectedDocument === "Passport Details")
          savePassport(selectedDocument, values);
      })
      .catch((errorInfo) => {
        console.log("Validation failed:", errorInfo);
      });
  };
  return (
    <div className="mobile-card">
      <Card
        style={{ padding: 20, borderRadius: "10px", width: "95%" }}
        bordered={false}
      >
        {user && user.role === "4" && (
          <div style={{ float: "right", marginTop: "-30px" }}>
            Remaining Days: {remainingDays} Days
          </div>
        )}
        <h2 style={{ textAlign: "center", marginBottom: "20px" }}>
          Document Verification System
        </h2>

        <Tabs
          defaultActiveKey="Vehicle Number"
          onChange={handleTabChange}
          type="scrollable"
        >
          <TabPane tab="Vehicle Number" key="Vehicle Number" />
          <TabPane tab="Driving License" key="Driving License" />
          <TabPane tab="Aadhar Number" key="Aadhar Number" />
          <TabPane tab="Aadhar Number (OTP)" key="Aadhar Number (OTP)" />
          <TabPane tab="Voter ID" key="Voter ID" />
          <TabPane tab="Passport" key="Passport Details" />
        </Tabs>

        <Form form={form} layout="vertical" style={{ marginTop: 20 }}>
          {selectedDocument === "Aadhar Number (OTP)" && (
            <>
              <Form.Item
                label={`Enter Aadhar Number:`}
                name="aadhar_number"
                onChange={(e) => handleAadhaarChange(e.target.value)}
              >
                <Input
                  placeholder="Enter Aadhar Number"
                  disabled={showOtpField}
                  className={aadharError ? "ant-input-status-error" : ""}
                />
                <span style={{ color: "red" }}>
                  {aadharError ? aadharError : ""}
                </span>
              </Form.Item>
              {!showOtpField && (
                <Form.Item style={{ textAlign: "center" }}>
                  <Button
                    type="primary"
                    style={{
                      width: "15%",
                      backgroundColor: "#3366ff",
                      borderColor: "#3366ff",
                      borderRadius: "4px",
                    }}
                    onClick={generateAadharOtp}
                  >
                    Submit
                  </Button>
                </Form.Item>
              )}
            </>
          )}

          <Row gutter={24}>
            {(selectedDocument === "Aadhar Number (OTP)" && showOtpField) ||
            selectedDocument != "Aadhar Number (OTP)" ? (
              <Col span={12}>
                <Form.Item
                  label={`Enter ${selectedDocument}:`}
                  name="documentNumber"
                  rules={getValidationRules()}
                >
                  <Input
                    placeholder={getPlaceholder()}
                    disabled={submittedTabs[selectedDocument]}
                    onChange={handleInputChange}
                  />
                </Form.Item>
              </Col>
            ) : (
              ""
            )}
            {(selectedDocument === "Driving License" ||
              selectedDocument === "Passport Details") && (
              <Col span={12}>
                <Form.Item
                  label="Date of Birth:"
                  name="dob"
                  rules={[
                    {
                      required: true,
                      message: "Please enter your date of birth",
                    },
                  ]}
                >
                  <DatePicker
                    style={{ width: "100%" }}
                    format="MM/DD/YYYY"
                    inputReadOnly
                  />
                </Form.Item>
              </Col>
            )}
          </Row>

          {(selectedDocument === "Aadhar Number (OTP)" && showOtpField) ||
          selectedDocument != "Aadhar Number (OTP)" ? (
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item
                  name="type"
                  label="Select Option"
                  rules={[
                    { required: true, message: "Please select an option!" },
                  ]}
                >
                  <Select
                    placeholder="Select an option"
                    allowClear
                    getPopupContainer={(trigger) => trigger.parentNode}
                  >
                    <Option value="गुन्ह्यातिल आरोपी">गुन्ह्यातिल आरोपी</Option>
                    <Option value="जामीन साठी सादर केलेले डॉक्युमेंट">
                      जामीन साठी सादर केलेले डॉक्युमेंट
                    </Option>
                    <Option value="संशयास्पद">संशयास्पद</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="details"
                  label="Details"
                  rules={[
                    { required: true, message: "Please provide details!" },
                    {
                      max: 500,
                      message: "Details cannot exceed 500 characters.",
                    },
                  ]}
                >
                  <Input.TextArea placeholder="Enter details here" />
                </Form.Item>
              </Col>
            </Row>
          ) : (
            ""
          )}

          {(selectedDocument === "Aadhar Number (OTP)" && showOtpField) ||
          selectedDocument != "Aadhar Number (OTP)" ? (
            <Form.Item style={{ textAlign: "center" }}>
              <Button
                type="primary"
                style={{
                  width: "15%",
                  backgroundColor: "#3366ff",
                  borderColor: "#3366ff",
                  borderRadius: "4px",
                }}
                onClick={handleSubmit}
                disabled={submittedTabs[selectedDocument]}
              >
                Submit
              </Button>
            </Form.Item>
          ) : (
            ""
          )}
        </Form>

        <Table
          columns={columns}
          dataSource={data}
          loading={loading}
          rowKey="id"
          style={{ marginTop: "20px" }}
          pagination={{
            current: currentPage + 1,
            pageSize: pageSize,
            total: total || 0,
            onChange: handlePageChange,
          }}
        />
        <Modal
          top
          visible={isModalVisible}
          onCancel={handleModalClose}
          onOk={handleModalClose}
          width={95 + "%"}
          footer={null}
        >
          {selectedDocument === "Vehicle Number" ? (
            <ViewVehicleData data={selectedRecord}></ViewVehicleData>
          ) : selectedDocument === "Driving License" ? (
            <ViewDrivingLicenceData
              data={selectedRecord}
            ></ViewDrivingLicenceData>
          ) : selectedDocument === "Aadhar Number" ? (
            <ViewAadharData data={selectedRecord}></ViewAadharData>
          ) : selectedDocument === "Aadhar Number (OTP)" ? (
            <ViewAadharOTPData data={selectedRecord}></ViewAadharOTPData>
          ) : selectedDocument === "Voter ID" ? (
            <ViewVoterData data={selectedRecord}></ViewVoterData>
          ) : selectedDocument === "Passport Details" ? (
            <ViewPassportData data={selectedRecord}></ViewPassportData>
          ) : (
            ""
          )}

          {/* <pre>{JSON.stringify(selectedRecord, null, 2)}</pre> */}
        </Modal>
        {imageOpen && (
          <ImageViewOnly
            imageOpen={imageOpen}
            imageUrl={selectedImage}
            onClose={closeImageModal}
          />
        )}
      </Card>
    </div>
  );
};

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  const { pc_cities, basicDistricts } = professionals;
  return {
    user,
    users,
    pc_cities,
    basicDistricts,
  };
}

const DocumentVerificationModule =
  connect(mapStateToProps)(DocumentVerification);
export { DocumentVerificationModule as DocumentVerification };
